module.exports = __webpack_public_path__ + "static/img/PatrickCripps.eb2cdc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PatrickCripps.jpg
// module id = Hy1E
// module chunks = 0